<template>
  <div class="nav-center">
    <div class="configu">
      <div :class="['mailbox',configuShow==ind ? 'mailboxHover':'']"
           v-for="(item,ind) in configuration"
           :key="ind"
           @click="changeBox(ind)">{{item}}</div>
    </div>
    <div class="configuFloating"
         v-show="configuShow != -1">
      <div class="arrow-left"
           @click="changeLeftFn"
           :style="{display:tabCalc>scrollWidth?'block':'none'}"><i class="el-icon-arrow-left"></i></div>
      <!-- 订单 -->
      <!-- <div class="configuFloating-A"
           ref="scrollDom0"
           v-show="configuShow == 0"
           :style="{marginLeft:marginLeft+'px'}">
        <div>
          <div class="configu-B" @click="postMail(0)">
            <img :src="require('../assets/image/images/socialize/socialize_shopping_cart.png')"
                 alt="">
            <span>购物车</span>
          </div>
        </div>
        <div class="otherConfig" style="display:flex;">
            <div class="configu-B" @click="postMail(1)" style="paddingTop:1px;marginRight:6px;">
              <img :src="require('../assets/image/images/business/mail_be current.png')"
                  alt="">
              <span>全部订单</span>
            </div>
          <div>
            <div>
              <span class="configu-C" v-for="(item,ind) in configuContentF" :key="ind" @click="postMail(2+ind)">
                <span class="contacts">{{item}}</span>
              </span>
            </div>
            <div>
              <span class="configu-C" v-for="(item,ind) in configuContentG" :key="ind" @click="postMail(5+ind)">
                <span class="contacts">{{item}}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="otherConfig">
          <div>
            <span class="configu-C" v-for="(item,ind) in configuContentH" :key="ind" @click="postMail(7+ind)">
              <span class="contacts">{{item}}</span>
            </span>
          </div>
          <div>
            <span class="configu-C" v-for="(item,ind) in configuContentI" :key="ind" @click="postMail(9+ind)">
              <span class="contacts">{{item}}</span>
            </span>
          </div>
        </div>
      </div> -->
      <!-- 管理 -->
      <div class="configuFloating-A"
           ref="scrollDom0"
           v-show="configuShow == 0">
        <ul>
          <li v-for="(items,ind) in configuContentE"
              :key="ind"
              @click="inCommonUse(ind)">
            <img :src="items.img"
                 alt="">
            <span>{{items.name}}</span>
          </li>
        </ul>
        <!-- <div class="otherConfig">
          <div>
            <span class="configu-C" v-for="(item,ind) in configuContentX" :key="ind" @click="arrange(ind)">
              <span class="contacts" :style="{backgroundImage:'url('+item.img+')'}">{{item.name}}</span>
            </span>
          </div>
          <div>
            <span class="configu-C" v-for="(item,ind) in configuContentY" :key="ind" @click="arrange(2+ind)">
              <span class="contacts" :style="{backgroundImage:'url('+item.img+')'}">{{item.name}}</span>
            </span>
          </div>
        </div> -->
        <div class="otherConfig">
          <div>
            <span class="configu-C" v-for="(item,ind) in configuContentJ" :key="ind" @click="inCommonUse(5)">
              <span class="contacts">{{item}}</span>
            </span>
          </div>
        </div>
      </div>
      <!-- 发布 -->
      <!-- <div class="configuFloating-A"
           ref="scrollDom1"
           v-show="configuShow == 1">
        <ul>
          <li v-for="(items,ind) in configuContentD"
              :key="ind"
              @click="repeat(ind)">
            <img :src="items.img"
                 alt="">
            <span>{{items.name}}</span>
          </li>
        </ul>
        <div class="otherConfig">
           <div>
            <span class="configu-C" v-for="(item,ind) in configuContentZ" :key="ind" @click="uploads(ind)">
              <span class="contacts" :style="{backgroundImage:'url('+item.img+')'}">{{item.name}}</span>
            </span>
          </div>
          <div style="display:flex;">
            <div>
              <span class="configu-C" @click="share()">
                <span class="contacts share">分享</span>
              </span>
            </div>
            <div class="nextLevel">
              <span :class="['configu-C',repeats?'configu-C-hover':'']"
                    @click="repeats = !repeats">
                <span class="contacts forward">转发</span>
                <i class="el-icon-caret-bottom"></i>
              </span>
              <ul v-show="repeats">
                <li @click="repeat(2)"><span>转发到商圈</span></li>
                <li @click="repeat(3)"><span>转发给好友</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div> -->
      <div class="arrow-right"
           @click="changeRightFn"
           :style="{display:tabCalc>scrollWidth?'block':'none'}"><i class="el-icon-arrow-right"></i></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'socialize',
  props:{
    sanbaoId:String
  },
  data () {
    return {
      configuContentX:[{ img: require('../assets/image/images/socialize/treasures_jump.png'), name: '跳转配置' }, { img: require('../assets/image/images/socialize/treasures_share.png'), name: '分享配置' }],
      configuContentY:[{ img: require('../assets/image/images/socialize/treasures_address_book.png'), name: '通讯配置' }, { img: require('../assets/image/images/socialize/treasures_platform.png'), name: '平台融合配置' }],
      configuContentZ:[{ img: require('../assets/image/images/mailbox/upload_16.png'), name: '上传' }, { img: require('../assets/image/images/socialize/socialize_download.png'), name: '下载' },{ img: require('../assets/image/images/mailbox/print.png'), name: '打印' }],
      configuContentP:['已审批','我发起的'],
      configuContentO:['待审批','抄送的'],
      configuContentN:[{ img: require('../assets/image/images/business/business_third.png'), name: '金蝶' }, { img: require('../assets/image/images/business/business_third.png'), name: '用友' },{ img: require('../assets/image/images/business/business_third.png'), name: '飞书' }, { img: require('../assets/image/images/business/business_third.png'), name: '钉钉' },{ img: require('../assets/image/images/business/business_third.png'), name: '泛微' },{ img: require('../assets/image/images/business/business_third.png'), name: '腾讯会议' }],
      configuContentM:['即时通知','预警通知'],
      configuContentL:['代办通知','工作通知'],
      configuContentJ:['皮肤管理'],
      configuContentI:['可追评订单'],
      configuContentH:['待评价订单','已评价订单'],
      configuContentG:['待执行订单','已取消订单'],
      configuContentF:['待付款订单','待交付订单','已完成订单'],
      configuContentE:[{ img: require('../assets/image/images/mailbox/mail_account_number.png'), name: '账号配置' }, { img: require('../assets/image/images/mailbox/mail_account_number_third.png'), name: '第三方账号配置' }],
      configuContentD: [{ img: require('../assets/image/images/business/mail_be current.png'), name: '发布' }],
      configuContentC: [{ img: require('../assets/image/images/business/business_approve.png'), name: '发起审批' }],
      configuration: ['管理','首页'],
      configuShow: -1,
      repeats: false,
      postMails:false,
      community:false,
      tabCalc: 0,
      scrollWidth: window.innerWidth,
      speed: 0,
      marginLeft: 0,
      pfId:this.getQuery('pfId'),
      bulletinBoard:false,
    }
  },
  mounted () {
    window.onresize = () => {
      this.scrollWidth = window.innerWidth;
    }
  },
  computed:{
    userId () {
      return this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : ''
    },
    userName () {
      return this.$store.state.userInfo.userName ? this.$store.state.userInfo.userName : ''
    },
  },
  methods: {
    hideSelect(){
      this.configuShow = -1;
    },
    changeBox (ind) {
      if (ind == 1) {
        this.$emit('emitJumpUrl',{url:''});
        return;
      }
      if (this.configuShow == ind) {
        this.configuShow = -1;
      } else {
        this.configuShow = ind;
        this.marginLeft = 0;
        this.speed = 0; 
        this.$nextTick(() => {
          this.tabCalc = this.$refs['scrollDom' + ind].clientWidth + 16;
        })
      }
      this.repeats = false;
      this.postMails = false;
    },
    changeLeftFn () {
      if (this.speed == 0) {
        return false;
      }
      this.speed++;
      this.marginLeft = this.speed * 150;
    },
    changeRightFn () {
      if (this.tabCalc + this.marginLeft < this.scrollWidth) {
        return false;
      }
      this.speed--;
      this.marginLeft = this.speed * 150;
    },
    iframeOpen(url){
      var iframe = document.getElementById("deliverable");
      if (iframe) {
        var iframe1 = iframe.contentWindow.document.querySelector('iframe[name="EQIframe"]');
        if(iframe1){
          iframe1.setAttribute("src", url);
          this.configuShow=-1;
        }
      }
    },
    iframeMethod(ind,method){
      switch (ind){
        case 0 :
          var iframe = document.getElementById("deliverable");
          if (iframe && iframe.contentWindow[method]) {
            iframe.contentWindow[method]();
            this.configuShow=-1;
          }
          break;
        case 1 :
          var iframe = document.getElementById("deliverable");
          if (iframe) {
            var iframe1 = iframe.contentWindow.document.getElementById("mainFrame");
            if(iframe1 && iframe1.contentWindow[method]) {
              iframe1.contentWindow[method]();
              this.configuShow=-1;
            }
          }
          break;
      }
    },
    arrange(ind){
      switch (ind){
        case 0 :
          //跳转配置
          this.iframeOpen(window.location.origin + '/esbserver/api/apiapp/list?appType=1&rlType=1&pfId='+ this.pfId);
          break;
        case 1 :
          //分享配置
          this.iframeOpen(window.location.origin + '/esbserver/api/apiapp/list?appType=1&rlType=2&pfId='+ this.pfId);
          break;
        case 2 :
          //通讯配置
          this.iframeOpen(window.location.origin + '/esbserver/api/apiapp/list?appType=1&rlType=3&pfId='+ this.pfId);
          break;
        case 3 :
          //平台融合配置
          this.iframeOpen(window.location.origin + '/esbserver/api/apiapp/list?appType=1&rlType=4&pfId='+ this.pfId);
          break;
      }
    },
    uploads(ind){
      switch (ind){
        case 0 :
          //上传
          this.iframeOpen(window.location.origin + '/cme-sso-app/space/upload-page.htm');
          break;
        case 1 :
          //下载
          this.downLoad();
          break;
        case 2 :
          //打印
          break;
      }
    },
    postMail(ind){
      switch (ind){
        case 0 :
          //购物车
          this.iframeOpen(window.location.origin + '/uoqid/shopCart?appId=zjsqe');
          break;
        case 1 :
          //全部订单
          this.iframeOpen(window.location.origin + '/oqmid-pay-tool-web/shop/order/list?pfId='+this.pfId);
          break;
        case 2 :
          //待付款订单
          this.iframeOpen(window.location.origin + '/oqmid-pay-tool-web/shop/order/list?types=1&pfId='+this.pfId);
          break;
        case 3 :
          //待交付订单
          this.iframeOpen(window.location.origin + '/oqmid-pay-tool-web/shop/order/list?types=3&pfId='+this.pfId);
          break;
        case 4 :
          //已完成订单
          this.iframeOpen(window.location.origin + '/oqmid-pay-tool-web/shop/order/list?types=4&pfId='+this.pfId);
          break;
        case 5 :
          //待执行订单
          this.iframeOpen(window.location.origin + '/oqmid-pay-tool-web/shop/order/list?types=2&pfId='+this.pfId);
          break;
        case 6 :
          //已取消订单
          this.iframeOpen(window.location.origin + '/oqmid-pay-tool-web/shop/order/list?types=0&pfId='+this.pfId);
          break;
        case 7 :
          //待评价订单
          this.iframeOpen(window.location.origin + '/oqmid-pay-tool-web/shop/evaluate/to-evaluate-order?isEvaluation=0&isSuperaddite=0&types=1&pfId='+this.pfId);
          break;
        case 8 :
          //已评价订单
          this.iframeOpen(window.location.origin + '/oqmid-pay-tool-web/shop/evaluate/to-evaluate-order?isEvaluation=1&isSuperaddite=1&types=1&pfId='+this.pfId);
          break;
        case 9 :
          //可追评订单
          this.iframeOpen(window.location.origin + '/oqmid-pay-tool-web/shop/evaluate/to-evaluate-order?isEvaluation=1&isSuperaddite=0&types=1&pfId='+this.pfId);
          break;
      }
    },
    inCommonUse(ind){
      switch (ind){
        case 0 :
          //账号配置
          this.iframeOpen(window.location.origin + '/acnid-project-approve/custom/socialMediaAccount/list?types=1');
          break;
        case 1 :
          //第三方账号配置
          this.iframeOpen(window.location.origin + '/esbserver/api/apiapp/wn-list?appType=1&pfId='+this.pfId);
          break;
        case 5 :
          //皮肤管理
          this.iframeOpen(window.location.origin + '/zciid-deliverable/shell/base/theme/set?dataId='+this.pfId+'&userId='+this.userId);
          break;
      }
    },
    share(){
      //分享
      this.iframeOpen(window.location.origin + '/esbserver/api/apiapp/dx-list?nextStep=true&appId=zjsqsanbao&appType=1')
    },
    downloads(){
      this.downLoad();
    },
    repeat(ind){
      switch (ind){
        case 0 :
          //发布
          this.iframeOpen(window.location.origin + '/zciid-deliverable/display/list?openType=social&pfId='+this.pfId+'&appId=&userId='+this.userId);
          break;
        case 1 :
          //更新发布
          this.iframeOpen(window.location.origin + '/zciid-deliverable/display/list?resourceAppId=yyzzzgxfb&flowId=scgid-yyzzzgxfb-Z-guru-flow-84452322947');
          break;
        case 2 :
          //转发到商圈
          this.iframeOpen(window.location.origin + '/zciid-deliverable/interface/deliverables/transmit/circle/list?pfId='+this.pfId+'&userId='+this.userId);
          break;
        case 3 :
          //转发到好友
          this.iframeOpen(window.location.origin + '/zciid-deliverable/interface/deliverables/transmit/user/list?pfId='+this.pfId+'&userId='+this.userId);
          break;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 450px) {
  .navbars .nav-center {
    display: none;
  }
}
.navbars .nav-center {
  height: 100%;
  flex-grow: 1;
  padding-left: 45px;
  -webkit-app-region: no-drag;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #fff;
}
.navbars span {
  color: #333;
}
.navbars .configu {
  display: flex;
}
.navbars .configu .mailbox {
  padding: 0 10px;
  height: 100%;
  line-height: 60px;
  cursor: pointer;
}
.navbars .configu .mailbox:hover,
.navbars .mailboxHover {
  background: -webkit-linear-gradient(top, #356eb3, #235da4);
  /*  Safari 5.1 到 6.0 */
  background: -o-linear-gradient(bottom, #356eb3, #235da4);
  /*  Opera 11.6 到 12.0 */
  background: -moz-linear-gradient(bottom, #356eb3, #235da4);
  /*  Fx 3.6 到 15 */
  background: linear-gradient(to bottom, #356eb3, #235da4);
}
.navbars .configuFloating {
  position: fixed;
  z-index: 1;
  top: 60px;
  left: 0;
  width: 100%;
  height: 77px;
  background-color: #fff;
  border-bottom: 1px solid #ddd;
  padding: 8px;
  box-sizing: border-box;
  .arrow-left,
  .arrow-right {
    height: 77px;
    line-height: 77px;
    color: #333;
    background-color: #efefef;
    position: absolute;
    top: 0;
    z-index: 100;
    cursor: pointer;
  }
  .arrow-left {
    left: 0;
  }
  .arrow-right {
    right: 0;
  }
}
.navbars .configuFloating-A {
  display: flex;
  position: absolute;
  z-index: 99;
  transition: .3s all;
  span {
    line-height: 20px;
  }
  img {
    width: 32px;
    height: 32px;
  }
  > div {
    padding: 0 8px;
    border-right: 1px solid #ddd;
    div.configu-B {
      padding: 4px 8px;
      display: flex;
      align-items: center;
      flex-direction: column;
      cursor: pointer;
    }
    div.configu-B:hover {
      background-color: #c1defa;
    }
  }
  > ul {
    display: flex;
    padding: 0 8px;
    border-right: 1px solid #ddd;
    li {
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 4px 8px;
      cursor: pointer;
    }
    li:hover {
      background-color: #c1defa;
    }
  }
  .filter {
    padding-left: 18px;
    background: url("../assets/image/images/business_zsb.png") no-repeat left
      center / 14px 14px;
  }
  .searchBox {
    position: relative;
    input {
      text-indent: 3px;
      padding: 3px 20px 3px 3px;
      border: 1px solid #ddd;
    }
    span {
      position: absolute;
      top: 1px;
      right: 6px;
      width: 16px;
      height: 16px;
      cursor: pointer;
      background: url("../assets/images/icons/member_icon_header.png") no-repeat -20px -32px /
        40px;
    }
  }
  .nextLevel {
    position: relative;
    ul {
      position: absolute;
      top: 28px;
      left: 0;
      height: 218px;
      background-color: #fff;
      border: 1px solid #e4e7ed;
      padding: 6px 0;
      li {
        cursor: pointer;
        span {
          min-width: 98px;
          max-width: 130px;
          height: 28px;
          line-height: 28px;
          display: inline-block;
          padding: 0 20px 0 10px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      li:hover {
        background-color: #c1defa;
      }
    }
  }
  .contacts {
    padding-left: 18px;
    background: url("../assets/image/images/mailbox/mail_be_current_small.png")
      no-repeat left center / 14px 14px;
  }
  .otherConfig {
    padding-top: 3px;
    .filterMessages {
      background: url("../assets/image/images/mailbox/mail_screen.png")
        no-repeat left center / 14px 14px;
    }
    .share {
      background: url("../assets/image/images/mailbox/mail_share.png")
        no-repeat left center / 14px 14px;
    }
    .forward {
      background: url("../assets/image/images/mailbox/mail_forward.png")
        no-repeat left center / 14px 14px;
    }
    .duplicate {
      background: url("../assets/image/images/business/device_message_board_small.png")
        no-repeat left center / 14px 14px;
    }
    .download {
      background: url("../assets/image/images/socialize/socialize_download.png")
        no-repeat left center / 14px 14px;
    }
  }
  .configu-C {
    display: inline-block;
    padding: 4px;
    cursor: pointer;
    i {
      color: #999;
    }
  }
  .configu-C:hover,
  .configu-C-hover {
    background-color: #c1defa;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/socialize.vue